import FullScreenErrorModal from '../../modal/FullScreenErrorModal';
import React from 'react';
import { ErrorNoticeContent } from '../errorComponents/getErrorNoticeContent';

type Props = {
    boardId: string;
    errorNoticeData: object | undefined;
    errorNoticeContent: ErrorNoticeContent | undefined;
    close: () => void;
};

const DesktopErrorModal: React.FC<Props> = ({ errorNoticeContent, errorNoticeData, boardId, close }) => {
    if (!errorNoticeContent) return null;

    const { component: ErrorNoticeContent, withoutModalOverlay, preventModalClose } = errorNoticeContent;

    return (
        <FullScreenErrorModal overlay={!withoutModalOverlay} close={preventModalClose ? undefined : close}>
            <ErrorNoticeContent
                {...errorNoticeData}
                errorNoticeData={errorNoticeData}
                boardId={boardId}
                close={close}
            />{' '}
        </FullScreenErrorModal>
    );
};

export default DesktopErrorModal;
